/* eslint-disable react/no-find-dom-node */
import React from 'react';
import ReactDOM from 'react-dom';

export default function clickOutside(Component) {
  const componentName = Component.displayName || Component.name;

  class EnhancedComponent extends React.Component {
    constructor(props) {
      super(props);

      this.componentRef = React.createRef();
      this.handleClickOutside = this.handleClickOutside.bind(this);
      this.handleKeyUp = this.handleKeyUp.bind(this);
    }

    componentDidMount() {
      document.addEventListener('click', this.handleClickOutside, true);
      document.addEventListener('keyup', this.handleKeyUp, true);
    }

    componentWillUnmount() {
      document.removeEventListener('click', this.handleClickOutside, true);
      document.removeEventListener('keyup', this.handleKeyUp, true);
    }

    handleKeyUp(e) {
      const escapeKeyCode = 27;
      const reactNode = this.componentRef.current;

      if (e.keyCode === escapeKeyCode && reactNode?.props?.rootClose) {
        if (typeof reactNode.handleClickOutside === 'function') {
          reactNode.handleClickOutside(e);
        } else if (typeof reactNode.props.handleClickOutside === 'function') {
          reactNode.props.handleClickOutside(e);
        }
      }
    }

    handleClickOutside(e) {
      const reactNode = this.componentRef.current;

      if (!reactNode || !reactNode?.props?.rootClose) {
        return;
      }

      const thisDomNode = ReactDOM.findDOMNode(this); // e.g. the tooltip
      if (thisDomNode?.contains(e.target)) {
        // Click was either on the target or on the wrapped content
        return;
      }

      // eslint-disable-next-line react/prop-types
      const targetDomNode = this.props.target && ReactDOM.findDOMNode(this.props.target); // e.g. the button with a tooltip
      if (targetDomNode && targetDomNode.contains(e.target)) {
        e.stopPropagation();
        e.preventDefault();
      }

      if (typeof reactNode.handleClickOutside === 'function') {
        reactNode.handleClickOutside(e);
      } else if (typeof reactNode.props.handleClickOutside === 'function') {
        reactNode.props.handleClickOutside(e);
      }
    }

    render() {
      return <Component {...this.props} ref={this.componentRef} />;
    }
  }

  EnhancedComponent.displayName = `clickOutside(${componentName})`;

  return EnhancedComponent;
}
